import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api/index.ts";

export interface WordCloudData {
  words: Array<{ text: string; value: number }>;
  metadata: {
    totalMessages: number;
    uniqueWords: number;
    dateRange: { start: string | null; end: string | null };
    filters: {
      mentorId?: string;
      menteeId?: string;
      source: string;
    };
  };
}

export const useWordCloud = (
  startDate?: string,
  endDate?: string,
  mentorId?: string,
  menteeId?: string,
  source?: "all" | "mentee" | "mentor",
  limit?: number,
) => {
  return useQuery<WordCloudData>({
    queryKey: [
      "word-cloud",
      startDate,
      endDate,
      mentorId,
      menteeId,
      source,
      limit,
    ],
    queryFn: async () => {
      const { data } = await fetchApi<WordCloudData>({
        url: "v2/admin/word-clouds",
        method: "GET",
        params: {
          startDate,
          endDate,
          mentorId,
          menteeId,
          source,
          limit,
        },
      });

      if (!data) {
        throw new Error("Failed to fetch word cloud data");
      }

      return data;
    },
    staleTime: 60 * 1000 * 5, // 5 minutes
  });
};
